module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp12_5010.c10c2494.png";